import store from './store';
import { $themeConfig } from '../theme.config';

export default {
    init() {
        // Nastaviť predvolené štýly
        let val = localStorage.getItem('dark_mode'); // light, dark, system
        if (!val) {
            val = $themeConfig.theme;
        }
        store.commit('toggleDarkMode', val);

        val = localStorage.getItem('menu_style'); // vertical, collapsible-vertical, horizontal
        if (!val) {
            val = $themeConfig.navigation;
        }
        store.commit('toggleMenuStyle', val);

        val = localStorage.getItem('layout_style'); // full, boxed-layout, large-boxed-layout
        if (!val) {
            val = $themeConfig.layout;
        }
        store.commit('toggleLayoutStyle', val);

        // Nastaviť jazyk - prioritizovať jazyk z API (ak je používateľ prihlásený), potom localStorage, nakoniec predvolený
        const user = store.state.auth.userData;
        let languageFromApi = null;
        
        // Skontrolovať jazyk z API (ak je používateľ prihlásený)
        if (user) {
            if (user.pouzivatel && user.pouzivatel.language) {
                languageFromApi = user.pouzivatel.language;
            } else if (user.language) {
                languageFromApi = user.language;
            }
        }
        
        // Ak máme jazyk z API, použiť ho
        if (languageFromApi) {
            const list = store.state.countryList;
            const item = list.find(item => item.code === languageFromApi);
            if (item) {
                store.commit('toggleLocale', languageFromApi);
                return;
            }
        }
        
        // Ak nie je jazyk z API, skúsiť localStorage
        val = localStorage.getItem('i18n_locale');
        if (val) {
            const list = store.state.countryList;
            const item = list.find(item => item.code === val);
            if (item) {
                store.commit('toggleLocale', val);
                return;
            }
        }
        
        // Ak nie je ani v localStorage, nastav predvolený
        val = $themeConfig.lang;
        const list = store.state.countryList;
        const item = list.find(item => item.code === val);
        if (item) {
            this.toggleLanguage(item);
        } else {
            store.commit('toggleLocale', 'sk');
        }
    },

    toggleLanguage(item) {
        let lang = null;
        if (item) {
            lang = item;
        } else {
            let code = store.state.locale;
            if (!code) {
                code = localStorage.getItem('i18n_locale');
            }

            item = store.state.countryList.find(d => d.code === code);
            if (item) {
                lang = item;
            }
        }

        if (!lang) {
            lang = store.state.countryList.find(d => d.code === 'sk');
        }

        store.commit('toggleLocale', lang.code);
        return lang;
    },

    toggleMode(mode) {
        if (!mode) {
            let val = localStorage.getItem('dark_mode'); //light|dark|system
            mode = val;
            if (!val) {
                mode = 'light';
            }
        }
        store.commit('toggleDarkMode', mode || 'light');
        return mode;
    }
};
